.g7{z-index:2;}